// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { ApplicationLastLayout } from '../Classes/ApplicationLastLayout';
import { ProjectViewLastLayout } from '../Classes/ProjectViewLastLayout';
export class ApplicationLayout {
  applicationLastLayout: ApplicationLastLayout;
  projectViewLastLayout: ProjectViewLastLayout;
}
